/**
 * NavigationHandler — hamburger menu, submenu, keyboard focus.
 * Migrated from dpss-theme.js lines 61-173.
 */

export class NavigationHandler {
  private container: HTMLElement | null;

  constructor() {
    this.container = document.getElementById("site-navigation");
    this.init();
  }

  private init(): void {
    if (!this.container) return;

    const button = this.container.querySelector("button");
    const menu = this.container.querySelector("ul");
    if (!button || !menu) return;

    if (!menu.classList.contains("nav-menu")) {
      menu.classList.add("nav-menu");
    }

    button.addEventListener("click", (e) => {
      e.preventDefault();
      this.toggleMenu();
    });

    document.addEventListener("click", (e) => {
      if (!this.container!.contains(e.target as Node)) {
        this.closeMenu();
      }
    });

    this.initTouchSupport();
    this.initFocusSupport(menu);
  }

  private toggleMenu(): void {
    if (this.container!.classList.contains("toggled")) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  private openMenu(): void {
    const button = this.container!.querySelector("button");
    this.container!.classList.add("toggled");
    button?.setAttribute("aria-expanded", "true");
  }

  private closeMenu(): void {
    const button = this.container!.querySelector("button");
    this.container!.classList.remove("toggled");
    button?.setAttribute("aria-expanded", "false");
  }

  private initTouchSupport(): void {
    if (!("ontouchstart" in window)) return;

    const parentLinks = this.container!.querySelectorAll(
      ".menu-item-has-children > a, .page_item_has_children > a",
    );

    parentLinks.forEach((link) => {
      link.addEventListener(
        "touchstart",
        (e) => {
          const menuItem = link.parentNode as HTMLElement;
          if (!menuItem.classList.contains("focus")) {
            e.preventDefault();
            Array.from(menuItem.parentNode!.children).forEach((sibling) => {
              if (sibling !== menuItem) {
                sibling.classList.remove("focus");
              }
            });
            menuItem.classList.add("focus");
          } else {
            menuItem.classList.remove("focus");
          }
        },
        false,
      );
    });
  }

  private initFocusSupport(menu: Element): void {
    const links = menu.querySelectorAll("a");

    links.forEach((link) => {
      link.addEventListener("focus", NavigationHandler.toggleFocus, true);
      link.addEventListener("blur", NavigationHandler.toggleFocus, true);

      const parentLi = link.closest("li");
      if (
        parentLi &&
        (parentLi.classList.contains("menu-item-has-children") ||
          parentLi.classList.contains("page_item_has_children"))
      ) {
        parentLi.addEventListener("mouseenter", () =>
          parentLi.classList.add("focus"),
        );
        parentLi.addEventListener("mouseleave", () =>
          parentLi.classList.remove("focus"),
        );
      }
    });
  }

  private static toggleFocus(e: Event): void {
    let element: HTMLElement | null = e.target as HTMLElement;
    while (element && !element.classList.contains("nav-menu")) {
      if (element.tagName?.toLowerCase() === "li") {
        element.classList.toggle("focus");
      }
      element = element.parentElement;
    }
  }
}
